/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { atom, useRecoilValue, useSetRecoilState } from "recoil";
import { SelectedTagsAtom } from "../../../atoms/SelectedTags";
import useDebounce from "../../../utils/UseDebounce";
import CreateOrUpdateTag from "../../Modal/container/Tags/CreateOrUpdateTag";
import { useModal } from "../../Modal/Modal";
import SearchInput from "../../SearchInput";
import StyledButton from "../../StyledButton";
import TagBulkActions from "./TagBulkActions";

const Container = styled.div`
  width: 100%;
  height: fit-content;
  border-bottom: 1px solid #cccccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  padding-left: 25px;
  background-color: #ffffff;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const marginRight15 = css`
  margin-right: 15px;
`;

export const TagsSearch = atom({
  key: "TagsSearch",
  default: "",
});

export default function Header(): JSX.Element {
  const modal = useModal();
  const setTagsSearch = useSetRecoilState(TagsSearch);
  const selectedTags = useRecoilValue(SelectedTagsAtom);
  const [search, setSearch] = useState<string>("");
  const debouncedSearch = useDebounce(search, 800);

  useEffect(() => {
    setTagsSearch(search);
  }, [debouncedSearch]);

  return (
    <Container>
      <div style={{ width: 320 }}>
        <SearchInput
          placeholder="Search for tag name"
          value={search}
          handleChange={(evt) => setSearch(evt)}
        />
      </div>
      <Flex>
        {selectedTags.length > 1 && (
          <div css={marginRight15}>
            <TagBulkActions />
          </div>
        )}
        <StyledButton
          onClick={() =>
            modal.pushModal(
              <CreateOrUpdateTag onCancel={() => modal.popModal()} />,
              "Create tag"
            )
          }
        >
          Create a Tag
        </StyledButton>
      </Flex>
    </Container>
  );
}
